

export const SET_AUTH_STATE = 'SET_AUTH_STATE';
export const SET_DEFAULT_ADD_MOVIE_TITLE = 'SET_DEFAULT_ADD_MOVIE_TITLE';
export const SET_COMING_SOON_ADD_CONTEXT = 'SET_COMING_SOON_ADD_CONTEXT';


